import fetch from 'services/request';
import { IApiCreatePlaylistData, IApiGetPlaylistParam } from '../interfaces/api';

// const baseURL = 'api/v1/:merchant_code/demoData';

export const getDemoData = () => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({ data: { data: [] } });
    }, 1000);
  });
  // return fetch({
  //   method: 'get',
  //   url: `${baseURL}/getDemoData`,
  //   params: params as any
  // });
};

const getListPlaylists = (params: IApiGetPlaylistParam) => {
  return fetch({
    method: 'get',
    url: '/api/v1/manage-playlist/list',
    params,
  });
};

const createOrUpdatePlaylist = (data: IApiCreatePlaylistData) => {
  return fetch({
    method: 'post',
    url: '/api/v1/manage-playlist/create-or-update',
    body: data,
  });
};

const deletePlaylist = (playlistId: string) => {
  return fetch({
    method: 'delete',
    url: `/api/v1/manage-playlist/delete/${playlistId}`,
  });
};

const getDetailPlaylist = (playlistId: string) => {
  return fetch({
    method: 'get',
    url: `/api/v1/manage-playlist/detail/${playlistId}`,
  });
};

const setScreen = (playListId: string, screenIds: string[]) => {
  return fetch({
    method: 'post',
    url: '/api/v1/manage-playlist/set-screen',
    body: {
      playListId,
      screenId: screenIds[0],
    },
  });
};

const updateNamePlaylist = (playListId: string, name: string) => {
  return fetch({
    method: 'post',
    url: '/api/v1/manage-playlist/update-name',
    body: {
      playListId,
      name,
    },
  });
};
/**
 * TODO:
 * please replace channel to your feature name
 * ex:
 * playlistApis => bookingApis
 */
const playlistApis = {
  getDemoData,
  getListPlaylists,
  createOrUpdatePlaylist,
  deletePlaylist,
  getDetailPlaylist,
  setScreen,
  updateNamePlaylist,
};

export default playlistApis;
